<template>
  <div class="otp-container">
    <div class="otp-content">
      <h1 class="otp-title">修改密码</h1>
      <p class="otp-hint">首次登录需修改密码，请设置新密码</p>

      <el-form :model="pwdForm" :rules="pwdRules" ref="pwdForm" @submit.native.prevent>
        <el-form-item prop="lpassword">
          <el-input type="password" v-model="pwdForm.lpassword" placeholder="请输入原密码" show-password></el-input>
        </el-form-item>

        <el-form-item prop="newlpassword">
          <el-input type="password" v-model="pwdForm.newlpassword" placeholder="请输入新密码" show-password></el-input>
        </el-form-item>

        <el-form-item prop="confirmPassword">
          <el-input type="password" v-model="pwdForm.confirmPassword" placeholder="请确认新密码" show-password></el-input>
        </el-form-item>

        <div class="otp-message" v-if="errorMessage">
          <el-alert :title="errorMessage" type="error" :closable="false" show-icon></el-alert>
        </div>

        <el-button class="otp-submit-button" type="primary" @click="submitChangePassword" :loading="submitting">确认修改</el-button>
      </el-form>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ChangePassword',
  props: {
    userInfo: {
      type: Object,
      default: null
    },
    updPasswordUrl: {
      type: String,
      default: 'coupon-merch/merch/updPassword'
    }
  },
  data() {
    const validateConfirmPassword = (rule, value, callback) => {
      if (value !== this.pwdForm.newlpassword) {
        callback(new Error('两次输入的密码不一致'));
      } else {
        callback();
      }
    };

    return {
      pwdForm: {
        lpassword: '',
        newlpassword: '',
        confirmPassword: ''
      },
      submitting: false,
      errorMessage: '',
      pwdRules: {
        lpassword: [
          { required: true, message: '请输入原密码', trigger: 'blur' }
        ],
        newlpassword: [
          { required: true, message: '请输入新密码', trigger: 'blur' },
          { min: 8, message: '密码长度不能少于8位', trigger: 'blur' }
        ],
        confirmPassword: [
          { required: true, message: '请确认新密码', trigger: 'blur' },
          { validator: validateConfirmPassword, trigger: 'blur' }
        ]
      }
    };
  },
  methods: {
    // 密码复杂性校验
    validatePasswordComplexity(newPwd, oldPwd) {
      // 1. 新密码不能与原密码相同
      if (newPwd === oldPwd) {
        return '新密码不能与原密码相同';
      }

      // 2. 不能重复使用同一文字三次（如 aaa, 333）
      if (/(.)\1{2,}/.test(newPwd)) {
        return '密码中不能连续出现三次相同字符';
      }

      // 3. 不能使用连续3位以上字段（正序或倒序），如123, abc, cba, 321
      const checkConsecutive = (str) => {
        for (let i = 0; i < str.length - 2; i++) {
          const c1 = str.charCodeAt(i);
          const c2 = str.charCodeAt(i + 1);
          const c3 = str.charCodeAt(i + 2);
          // 正序连续
          if (c2 - c1 === 1 && c3 - c2 === 1) return true;
          // 倒序连续
          if (c1 - c2 === 1 && c2 - c3 === 1) return true;
        }
        return false;
      };
      if (checkConsecutive(newPwd)) {
        return '密码中不能包含3位及以上连续字符（如123、abc、321、cba）';
      }

      // 4. 密码里不能包含ID信息（商户号）
      if (this.userInfo && this.userInfo.merchno && newPwd.indexOf(this.userInfo.merchno) !== -1) {
        return '密码中不能包含商户号信息';
      }
      if (this.userInfo && this.userInfo.lbh && newPwd.indexOf(this.userInfo.lbh) !== -1) {
        return '密码中不能包含账号信息';
      }

      // 5. 不能全数字
      if (/^\d+$/.test(newPwd)) {
        return '密码不能全为数字';
      }

      // 6. 不能全字母
      if (/^[a-zA-Z]+$/.test(newPwd)) {
        return '密码不能全为字母';
      }

      return null;
    },

    submitChangePassword() {
      this.$refs.pwdForm.validate((valid) => {
        if (!valid) return;

        this.errorMessage = '';

        // 密码复杂性校验
        const complexityError = this.validatePasswordComplexity(this.pwdForm.newlpassword, this.pwdForm.lpassword);
        if (complexityError) {
          this.errorMessage = complexityError;
          return;
        }

        const _this = this;
        _this.submitting = true;

        _this.$ajax({
          url: _this.updPasswordUrl,
          methods: 'POST',
          data: {
            merchno: _this.userInfo ? _this.userInfo.merchno : '',
            lpassword: _this.pwdForm.lpassword,
            newlpassword: _this.pwdForm.newlpassword
          },
          token: window.sessionStorage.getItem('token'),
          success: function(response) {
            _this.submitting = false;
            if (response.code === 0) {
              _this.$emit('change-success');
            } else {
              _this.errorMessage = response.message || '修改密码失败';
            }
          },
          error: function() {
            _this.submitting = false;
            _this.errorMessage = '修改密码失败，请稍后重试';
          }
        });
      });
    }
  }
};
</script>

<style scoped>
.otp-container {
  display: flex;
  align-items: center;
  justify-content: center;
  overflow-y: auto;
}

.otp-content {
  position: relative;
  width: 100%;
  max-width: 480px;
  text-align: center;
  max-height: 100vh;
  overflow-y: auto;
  padding: 10px 0;
}

.otp-title {
  font-size: 28px;
  font-weight: 600;
  margin: 0 0 16px 0;
  color: #303133;
}

.otp-hint {
  font-size: 14px;
  color: #606266;
  margin: 0 0 24px 0;
  line-height: 1.6;
}

.otp-message {
  min-height: 24px;
  margin-bottom: 16px;
  display: flex;
  justify-content: center;
  align-items: center;
}

.otp-submit-button {
  width: 100%;
  height: 44px;
  font-size: 16px;
  font-weight: 500;
}
</style>



// WEBPACK FOOTER //
// src/components/changePassword.vue